import http from "../http-common";


const getTimeZones = () => {
  return http.get("/get-all-timezone");
};
const TimeZoneService = {
    getTimeZones,
}
export default TimeZoneService;